// extracted by mini-css-extract-plugin
export default {"message":"frame__message__Q5u8ia","messageText":"frame__messageText__Qoapc2"};